export default __webpack_public_path__ + "static/media/framefacebook.a8aa5b60.svg";